import { Typography, Card, Modal, message, Dropdown } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { CompleteTickets, InprogressTickets, TicketDetail, UpdateObstacleTicketRequest } from 'types';
import { requestform } from 'messages';
import { GreenCheck, PrinterIcon } from 'assets';
import { GetTicketDetail } from 'hooks/request-form';

import defaultTicketDetail from 'types/dto/request-form/request-form.dto';
import PrintComponent from '../print-ticket/PrintTikcet';
import NormalTicket from '../print-ticket-detail/NormalTicket';
import { useReactToPrint } from 'react-to-print';
import RequestStatusBar from '../request-form/RequestStatusBar';
import RequestDetailCmisTransferInformation from '../request-form/RequestDetailCmisTransferInformation';
import RequestDetailProcessing from '../request-form/RequestDetailProcessing';
import RequestDetailCreateFormInformation from '../request-form/RequestDetailCreateFormInformation';
import RequestDetailMainInformation from '../request-form/RequestDetailMainInformation';

interface ticketFromDetail {
  status?: string;
  ticketId: number;
}

const CustomerHistoryRequest: React.FC<ticketFromDetail> = ({ status = 'pending_reception', ticketId }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  // Main request detail
  const [ticketStatus, setTicketStatus] = useState(status);
  const [requestTicketId, setRequestTicketId] = useState<number>(ticketId);
  const { requestDetail, refetch } = GetTicketDetail(requestTicketId);

  // Control state
  const [requestItem, setRequestItem] = useState<TicketDetail>(defaultTicketDetail);

  useEffect(() => {
    setRequestItem(requestDetail);
  }, [requestDetail]);

  const changeTicketDetail = (newTicketId: number) => {
    setRequestTicketId(newTicketId);
    setTicketStatus(requestDetail?.status.code);
  };

  return (
    <Card
      title={
        <Typography.Text className='w-full text-center text-[16px]/[22px] font-semibold'>
          {requestform.requestTicket} {requestDetail.ticketId}
        </Typography.Text>
      }
      className='request-form-detail-card  text-center'
    >
      <div style={{ display: 'none' }}>
        <PrintComponent ref={contentRef}>
          <NormalTicket isHistory={true} ticket={requestDetail} status={status} ticketId={ticketId} />
        </PrintComponent>
      </div>

      <div className='flex w-full text-left'>
        <div className='w-[250px]'>
          <RequestDetailCreateFormInformation requestItem={requestItem} />
        </div>

        <section className='flex flex-col justify-between'>
          <section className='h-[calc(95vh-8rem) w-[870px] overflow-y-auto p-6'>
            <section className='flex items-center justify-between'>
              <div className='w-4/5'>
                <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
                  {requestItem?.serviceType && requestItem?.serviceType?.name ? requestItem?.serviceType?.name : ''}
                </Typography.Text>
              </div>
              <button onClick={() => reactToPrintFn()} className='flex items-center space-x-2'>
                <PrinterIcon />
                <Typography.Text className='text-[16px]/[20px] text-[#1564E8]'>
                  {requestform.printTicket}
                </Typography.Text>
              </button>
            </section>

            <section>
              <Typography.Text
                className={`text-[14px]/[18px] ${requestItem?.isRequestMultipleTime ? 'text-[#D1131D]' : 'text-[#06A77D]'}`}
              >
                {requestItem?.isRequestMultipleTime
                  ? requestform.multiplleTimeRequest
                  : requestform.notMultiplleTimeRequest}
              </Typography.Text>
            </section>

            <section>
              {status && (
                <div className='pb-6'>
                  <RequestStatusBar status={status} />
                  {/* CMIS Transfer */}
                  {requestItem.cmisRequestId ? (
                    <button
                      // onClick={openCmisProcess}
                      className='mt-1 flex w-full justify-between rounded-[5px] bg-[#06A77D00] py-[11px] hover:bg-[#F5F5F7]'
                    >
                      <div className='flex space-x-1'>
                        <GreenCheck />
                        <Typography.Text className='text-[14px]/[18px] italic text-[#141414]'>
                          {requestform.cmisTranfered + requestItem.cmisRequestId}
                        </Typography.Text>
                      </div>{' '}
                    </button>
                  ) : (
                    <div className='mt-1 flex justify-between rounded-[5px] border border-[#D1131D] bg-[#06A77D00] px-4 py-[11px]'>
                      <div className='flex items-center space-x-2'>
                        <Typography.Text className='text-[14px]/[18px] font-semibold text-[#D1131D]'>
                          {requestform.cmisTransferFail}
                        </Typography.Text>{' '}
                        {/* <Typography.Text className='text-[14px]/[18px] text-[#141414]'>
                          <Dropdown overlay={menu} trigger={['click']}>
                            <div className='flex w-full cursor-pointer items-center justify-between space-x-2 border-[#EBEBED] bg-[#FFFFFF]'>
                              <Typography.Text className='text-[14px]/[18px]'>
                                {selectedOption?.name ? selectedOption?.name : requestform.typeCmisTicket}
                              </Typography.Text>
                              <DownOutlined className='h-2 w-[10px]' />
                            </div>
                          </Dropdown>
                        </Typography.Text>{' '} */}
                      </div>
                      {/* <button onClick={transferCmis}>
                        <Typography.Text className='text-[14px]/[18px] text-[#1564E8]'>
                          {requestform.tryAgainButton}
                        </Typography.Text>
                      </button> */}
                    </div>
                  )}
                </div>
              )}
            </section>

            <section className={`${status !== 'CHOTIEPNHAN' && status !== 'HUY' ? 'h-[calc(90vh-16rem)] overflow-y-auto' : 'max-h-[calc(90vh-20rem)] overflow-y-auto'}`}>
              <RequestDetailMainInformation requestItem={requestItem} isHistory={true} />
              <RequestDetailProcessing
                //Use for customer history request
                isHistory={true}
                requestItem={requestItem}
                processingContent={''}
              />
            </section>
          </section>
        </section>
      </div>
    </Card>
  );
};

export default CustomerHistoryRequest;
